import { Dayjs } from "dayjs";
import { CalendarItemMap } from "../Calendar/CalendarItemMap.ts";
import { SlotDayAndHourKey } from "../Calendar/SlotDayAndHourKey.ts";
import {
  CloserAvailabilityHourGroup,
  CloserAvailabilityNormalizedSlot,
  DISPLAY_TZ,
} from "./createCloserAvailabilityCalendarMap.ts";

export type CloserSlotTotals = {
  availableCount: number;
  callCount: number;
  oooCount: number;
};

const emptyTotals: CloserSlotTotals = {
  availableCount: 0,
  callCount: 0,
  oooCount: 0,
};

function addTotals(a: CloserSlotTotals, b: CloserSlotTotals): CloserSlotTotals {
  return {
    availableCount: a.availableCount + b.availableCount,
    callCount: a.callCount + b.callCount,
    oooCount: a.oooCount + b.oooCount,
  };
}

function totalsOfSlot(
  slot: CloserAvailabilityNormalizedSlot,
): CloserSlotTotals {
  return {
    availableCount: slot.availableUsers.length,
    callCount: slot.busyWorkUsers?.length ?? 0,
    oooCount: slot.busyOooUsers?.length ?? 0,
  };
}

export function sumCloserSlots(
  slots: CloserAvailabilityNormalizedSlot[],
): CloserSlotTotals {
  return slots.map(totalsOfSlot).reduce(addTotals, emptyTotals);
}

export function hasNoTotals(totals: CloserSlotTotals): boolean {
  return (
    totals.availableCount === 0 &&
    totals.callCount === 0 &&
    totals.oooCount === 0
  );
}

export function countTotalsOfDay(
  items: CalendarItemMap<CloserAvailabilityHourGroup>,
  day: Dayjs,
): CloserSlotTotals {
  const groups = items.getAllSlotOfADate(
    SlotDayAndHourKey.fromDate(day.tz(DISPLAY_TZ)),
  );
  return sumCloserSlots(groups.flatMap((group) => group.slots));
}
